import Skeleton from 'antd/es/skeleton';

import { useGetDisbursementWithdrawalAccounts } from 'api';

import { useOrganisationId } from 'hooks/context';

import { TableLayout } from 'components/ui/templates/TableLayout/TableLayout';

import type { FiltersState } from './localState';
import { useLocalState } from './localState';
import { NoWithdrawalAccounts } from './NoWithdrawalAccounts';
import { WithdrawalsHeader } from './WithdrawalsHeader';
import { WithdrawalsTable } from './WithdrawalsTable';

export const Withdrawals = () => {
  const organisationId = useOrganisationId<number>();

  const {
    state: localState,
    dispatch,
    resetState,
    setFilters: updateFilters,
    updateCursorAfter
  } = useLocalState();

  const {
    data: { data: withdrawalAccounts = [] } = {},
    isError: isWithdrawalAccountsError,
    isLoading: isWithdrawalAccountsLoading
  } = useGetDisbursementWithdrawalAccounts(organisationId);

  const setFilters = (value: FiltersState) => {
    dispatch(updateFilters(value));
  };

  if (isWithdrawalAccountsLoading) {
    return <Skeleton />;
  }

  if (withdrawalAccounts.length === 0) {
    return <NoWithdrawalAccounts />;
  }

  return (
    <TableLayout
      header={
        <WithdrawalsHeader
          filters={localState.filters}
          setFilters={setFilters}
          resetState={resetState}
          withdrawalAccounts={withdrawalAccounts}
          isWithdrawalAccountsError={isWithdrawalAccountsError}
          isWithdrawalAccountsLoading={isWithdrawalAccountsLoading}
        />
      }
      content={
        <WithdrawalsTable
          localState={localState}
          updateCursorAfter={updateCursorAfter}
        />
      }
    />
  );
};
